import { capitalizeFirstWord } from '../../../../utils/capitalizeFirstWord';
import { IPoiItem } from '../models/IPoiItem';

export const ALL_POI_TYPES_FILTER_RESET = 'All Types';

export const getPoiTypeKeywords = (poiData: IPoiItem[]) => {
	const displayTags = poiData.flatMap((poi) =>
		poi.tags.filter((tag) => tag.isDisplayed),
	);

	const keywords = displayTags.map((keyword) =>
		capitalizeFirstWord(keyword.name),
	);
	const uniqueKeywords = Array.from(new Set(keywords)).filter(
		(keyword) => !/^\$+$/.test(keyword), // Remove strings containing only dollar signs
	);

	// Keywords starting with a # or $ should be placed at the end of the list
	const sortedUniqueKeywords = uniqueKeywords.sort((a, b) => {
		const startsWithSpecialChar = (str: string) =>
			str.startsWith('#') || str.startsWith('$');

		if (startsWithSpecialChar(a) && !startsWithSpecialChar(b)) return 1;
		if (!startsWithSpecialChar(a) && startsWithSpecialChar(b)) return -1;
		return a.localeCompare(b);
	});

	return [ALL_POI_TYPES_FILTER_RESET, ...sortedUniqueKeywords];
};
